export const sidebarData = [
  {
    title: "Complaints",
    path: "/officer/home",
    icon: "🧾",
    cName: "nav-text",
  },
  {
    title: "Merged Complaints",
    path: "/officer/merge-complain",
    icon: "🧾",
    cName: "nav-text",
  },
  {
    title: "Your Profile",
    path: "/officer/profile",
    icon: "🧔🏻",
    cName: "nav-text",
  },
  // {
  //   title: "Analytics",
  //   path: "/officer/analytics",
  //   icon: "📈",
  //   cName: "nav-text",
  // },
  
];
